import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import Lozenge from "@atlaskit/lozenge";

// Utility to calculate remaining trial days
const calculateTrialDaysLeft = (installedDate) => {
    const installed = new Date(installedDate);
    const now = new Date();
    const trialPeriod = 45; // Trial is for 45 days
    const timeDiff = now - installed;
    const daysElapsed = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return trialPeriod - daysElapsed;
  };
  
const License = () => {
    const licenseData = useSelector((state) => state.jira.license);
    const [licenseStatus, setLicenseStatus] = useState('');
    const [daysLeft, setDaysLeft] = useState(null);
    const [appearance, setAppearance] = useState("success");
  
    useEffect(() => {
      if (licenseData.license) {
        // Handle bought license
        if (licenseData.license.active) {
          setLicenseStatus('Active License');
          setAppearance("success")
        } else {
          setLicenseStatus('Expired License');
          setAppearance("removed")
        }
      } else {
        // Handle trial license
        const daysLeft = calculateTrialDaysLeft(licenseData.installedDate);
        if (daysLeft > 0) {
          setLicenseStatus('Trial License');
          setAppearance("success")

          setDaysLeft(daysLeft);
        } else {
          setLicenseStatus('Trial Expired');
          setAppearance("removed")
        }
      }
    }, [licenseData]);

  
    return (
      <div>
        <h2>License Overview: {licenseData.name}</h2>
        <p>Monitor the status of your license, whether active or inactive. If your app license is inactive, all related integration flows will be automatically disabled to prevent unauthorized access. This ensures uninterrupted service by keeping licenses up-to-date.</p>
        <p><b>Status:</b>  <Lozenge appearance={appearance}>{licenseStatus}</Lozenge>
        </p>
        {daysLeft !== null && <p><b>Trial Days Left: </b>{daysLeft}</p>}
        <p><b>Installed Date:</b> {new Date(licenseData.installedDate).toLocaleDateString()}</p>
        <p><b>Last Updated:</b> {new Date(licenseData.lastUpdated).toLocaleDateString()}</p>
        <a href={licenseData.links.marketplace[0].href} target="_blank" rel="noopener noreferrer">
          View on Marketplace
        </a>
      </div>
    );
};
export default License;
